import React from 'react';
import LandingPageTemplate from '../../components/LandingPageTemplate';
import {
  Backup as BackupIcon,
  Shield as ShieldIcon,
  Speed as SpeedIcon,
  VerifiedUser as VerifiedIcon,
} from '@mui/icons-material';
import heroImage from '../../assets/images/hpe_servers/hpe-storage-default.jpg';

const VeeamLanding: React.FC = () => {
  return (
    <LandingPageTemplate
      headline="Protect Your Business with Veeam Backup"
      subheadline="Enterprise-grade backup and recovery that ensures your data is always protected and quickly recoverable."
      heroImage={heroImage}
      ctaText="Get a Quote"
      valueProps={[
        'Ransomware Protection',
        'Fast Recovery',
        'Automated Backups',
        'Cloud Integration',
        'Compliance Ready',
        'Proven Reliability',
      ]}
      features={[
        {
          title: 'Veeam Backup & Replication',
          description:
            'Industry-leading backup solution trusted by over 450,000 customers. Protect virtual, physical, and cloud workloads with a single platform.',
          icon: <BackupIcon />,
        },
        {
          title: 'Instant Recovery',
          description:
            'Recover entire VMs, files, or applications in seconds, not hours. Meet aggressive RTOs with instant VM recovery and file-level restore capabilities.',
          icon: <SpeedIcon />,
        },
        {
          title: 'Ransomware Protection',
          description:
            'Immutable backups and automatic malware detection protect against ransomware attacks. Keep your data safe with air-gapped repositories.',
          icon: <ShieldIcon />,
        },
        {
          title: 'Compliance & Reporting',
          description:
            'Meet regulatory requirements with comprehensive audit trails, encryption, and compliance reporting. Support for GDPR, HIPAA, and more.',
          icon: <VerifiedIcon />,
        },
      ]}
      stats={[
        { value: '450K+', label: 'Customers' },
        { value: '15 Min', label: 'Avg. Recovery' },
        { value: '99.999%*', label: 'Success Rate' },
        { value: '82%', label: 'Cost Savings' },
      ]}
      ctaHeadline="Ready to Protect Your Data with Veeam?"
      ctaDescription="Get a free backup assessment and customized data protection strategy from TNCOSOFT's Veeam certified engineers."
      primaryColor="#00B336"
      accentColor="#008025"
    />
  );
};

export default VeeamLanding;
